import React, { Component } from "react";
import {
  Card,
  CardBody,
  FormGroup,
  InputGroup,
  InputGroupAddon,
  Input,
  ButtonGroup,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  DropdownToggle,
  Row,
  Col,
  Button,
  Pagination,
  PaginationItem,
  PaginationLink,
  Table,
} from "reactstrap";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { AvForm } from "availity-reactstrap-validation";
import SimpleBar from "simplebar-react";
import moment from "moment";
import Swal from "sweetalert2";
import Defaultuser from "../../assets/images/users/Default_User.png";

import {
  SetParams,
  getRFQRequestList,
  toggleItemMenu,
  rf_model_list_open,
  listlayout,
  generateRFQasPDF,
} from "../../store/RequetForQuotation/actions";
import { rfqPdf } from "../../store/Reports/actions";
import LoadingModel from "../LoadingModel";

class AllRequestForQuotation extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.DownloadPDF = this.DownloadPDF.bind(this);
  }

  handleDelete(values) {
    this.props.purIntRequestDelete(values, this.props.history);
  }
  deleteRecord = (record) => {
    Swal.fire({
      icon: "error",
      // title: "Oops...",
      text: "Permission not allowed!",
    });
    // swal({
    //   title: "Are you sure?",
    //   text: "Once deleted, you will not be able to recover this imaginary file!",
    //   icon: "warning",
    //   buttons: true,
    //   dangerMode: true,
    // }).then((willDelete) => {
    //   if (willDelete) {
    //     this.handleDelete(record.id);
    //   } else {
    //     swal("Your imaginary file is safe!");
    //   }
    // });
  };

  //>>>>>>>>>>>>>>>>>>>>>>>>>>>
  DownloadPDF(id) {
    this.props.rfqPdf(true);
    this.props.history.push("/rfqreportdoc/" + id);
    // this.props.generateRFQasPDF(id);
  }

  onSortChange = () => {
    var sort = ["code", "createdon"];
    var currentSort = this.props.params.currentSort;
    var i = sort.indexOf(currentSort);
    if (i !== -1 && i + 1 < sort.length) {
      currentSort = sort[i + 1];
    } else {
      currentSort = sort[0];
    }
    this.props.SetParams({ ...this.props.params, currentSort: currentSort });
    this.props.getRFQRequestList({
      ...this.props.params,
      currentSort: currentSort,
    });
  };
  onSortOrderChange = () => {
    // var sort = ["", "-"];
    var sortOrder = this.props.params.sortOrder;
    if (sortOrder === "") {
      sortOrder = "-";
    } else {
      sortOrder = "";
    }

    this.props.SetParams({ ...this.props.params, sortOrder: sortOrder });
    this.props.getRFQRequestList({
      ...this.props.params,
      sortOrder: sortOrder,
    });
  };
  onlayoutChange = () => {
    var layout = this.props.layout;
    if (layout === "list") {
      layout = "table";
    } else {
      layout = "list";
    }
    this.props.listlayout(layout);
  };
  autohandleSearch = (e) => {
    this.props.SetParams({
      ...this.props.params,
      search: e.target.value,
      page: 1,
    });
    if (e.target.value === "") {
      this.props.getRFQRequestList(
        {
          ...this.props.params,
          search: "",
          page: 1,
        },
        true
      );
    }
  };
  handleSearch = (e) => {
    if (e.key === "Enter") {
      this.props.getRFQRequestList({
        ...this.props.params,
        page: 1,
        search: e.target.value,
      });
    }
  };
  openPage(pageNo) {
    this.props.SetParams({ ...this.props.params, page: pageNo });
    this.props.getRFQRequestList({ ...this.props.params, page: pageNo });
  }
  render() {
    return (
      <React.Fragment>
        {this.props.loading && <LoadingModel OpenModel={this.props.loading} />}

        <div className="mt-2 ">
          <div>
            <Row>
              <Col md={3}>
                <AvForm className="p-1">
                  <FormGroup className="m-0">
                    <InputGroup>
                      <Input
                        type="text"
                        name="search"
                        className="form-control d-inline-block"
                        placeholder="Search"
                        validate={{ required: true }}
                        onChange={(e) => this.autohandleSearch(e)}
                        onKeyDown={(e) => this.handleSearch(e)}
                      />
                      <InputGroupAddon addonType="append">
                        <Button
                          color="light"
                          type="submit"
                          onClick={() =>
                            this.props.getRFQRequestList({
                              ...this.props.params,
                              page: 1,
                            })
                          }
                        >
                          <i className="ri-search-line"></i>
                        </Button>
                      </InputGroupAddon>
                    </InputGroup>
                  </FormGroup>
                </AvForm>
              </Col>
              <Col md={9}>
                <div className="float-right p-1">
                  <div className="d-inline-block">
                    <Pagination aria-label="Page navigation example">
                      <PaginationItem disabled={this.props.params.page <= 1}>
                        <PaginationLink
                          onClick={(e) => this.openPage(1)}
                          previous
                          // href="#"
                        />
                      </PaginationItem>

                      {this.props.params.page > 2 && (
                        <PaginationItem disabled={this.props.params.page <= 2}>
                          <PaginationLink
                            onClick={() =>
                              this.openPage(this.props.params.page - 2)
                            }
                            // href="#"
                          >
                            {this.props.params.page - 2}
                          </PaginationLink>
                        </PaginationItem>
                      )}
                      {this.props.params.page > 1 && (
                        <PaginationItem disabled={this.props.params.page === 1}>
                          <PaginationLink
                            onClick={() =>
                              this.openPage(this.props.params.page - 1)
                            }
                            // href="#"
                          >
                            {this.props.params.page - 1}
                          </PaginationLink>
                        </PaginationItem>
                      )}

                      <PaginationItem active={true}>
                        <PaginationLink
                          onClick={() => this.openPage(this.props.params.page)}
                          // href="#"
                        >
                          {this.props.params.page}
                        </PaginationLink>
                      </PaginationItem>
                      {this.props.params.page + 1 <=
                        this.props.params.no_of_pages && (
                        <PaginationItem
                          disabled={
                            this.props.params.page + 1 >
                            this.props.params.no_of_pages
                          }
                        >
                          <PaginationLink
                            onClick={() =>
                              this.openPage(this.props.params.page + 1)
                            }
                            // href="#"
                          >
                            {this.props.params.page + 1}
                          </PaginationLink>
                        </PaginationItem>
                      )}
                      {this.props.params.page + 2 <=
                        this.props.params.no_of_pages && (
                        <PaginationItem
                          disabled={
                            this.props.params.page + 2 >
                            this.props.params.no_of_pages
                          }
                        >
                          <PaginationLink
                            onClick={() =>
                              this.openPage(this.props.params.page + 2)
                            }
                            // href="#"
                          >
                            {this.props.params.page + 2}
                          </PaginationLink>
                        </PaginationItem>
                      )}
                      {this.props.params.page + 3 <=
                        this.props.params.no_of_pages &&
                        this.props.params.page < 3 && (
                          <PaginationItem
                            disabled={
                              this.props.params.page + 3 >
                              this.props.params.no_of_pages
                            }
                          >
                            <PaginationLink
                              onClick={() =>
                                this.openPage(this.props.params.page + 3)
                              }
                              // href="#"
                            >
                              {this.props.params.page + 3}
                            </PaginationLink>
                          </PaginationItem>
                        )}
                      {this.props.params.page + 4 <=
                        this.props.params.no_of_pages &&
                        this.props.params.page < 2 && (
                          <PaginationItem
                            disabled={
                              this.props.params.page + 4 >
                              this.props.params.no_of_pages
                            }
                          >
                            <PaginationLink
                              onClick={() =>
                                this.openPage(this.props.params.page + 4)
                              }
                              // href="#"
                            >
                              {this.props.params.page + 4}
                            </PaginationLink>
                          </PaginationItem>
                        )}

                      <PaginationItem
                        disabled={
                          this.props.params.no_of_pages ===
                          this.props.params.page
                        }
                      >
                        <PaginationLink
                          onClick={(e) =>
                            this.openPage(this.props.params.no_of_pages)
                          }
                          next
                          // href="#"
                        />
                      </PaginationItem>
                    </Pagination>
                  </div>
                  <ButtonGroup className="waves-effect waves-light d-inline-block ml-2 mr-2">
                    <Button color="light" onClick={this.onSortOrderChange}>
                      {this.props.params.sortOrder === "" && (
                        <i className="mdi mdi-sort-ascending mr-1"></i>
                      )}
                      {this.props.params.sortOrder === "-" && (
                        <i className="mdi mdi-sort-descending mr-1"></i>
                      )}
                    </Button>
                    <Button color="light" onClick={this.onSortChange}>
                      {this.props.Sortvar[this.props.params.currentSort]}
                    </Button>
                  </ButtonGroup>
                  <Button color="light" onClick={this.onlayoutChange}>
                    {this.props.layout === "list" && (
                      <i className="mdi mdi-table-large"></i>
                    )}
                    {this.props.layout === "table" && (
                      <i className="mdi mdi-format-list-bulleted"></i>
                    )}
                  </Button>
                </div>
              </Col>
            </Row>
          </div>
          <SimpleBar style={{ minHeight: "10px" }}>
            <Card className="p-0">
              <CardBody className="p-2">
                {this.props.layout === "table" && (
                  <CardBody className="p-2 ">
                    <div className="table-responsive m-0">
                      <Table bordered hover className="mb-0 p-0 table-centered">
                        <thead className="bg-light text-center">
                          <tr>
                            <th className="nowrap">RFQ Code</th>
                            <th className="nowrap">No.of Items</th>

                            <th className="nowrap">Submited</th>
                            <th className="nowrap">Vendors</th>

                            <th className="nowrap">Action</th>
                          </tr>
                        </thead>
                        <tbody className="nowrap">
                          {this.props.RFQRowListCount !== 0 ? (
                            <>
                              {this.props.RFQrowlist?.map((item, key) => (
                                <tr key={key} className="text-center">
                                  <td>
                                    <Link to={`rfq/${item.id}`}>
                                      <Button
                                        type="button"
                                        color={
                                          item.rfqstatus === 1 ||
                                          item.rfqstatus === 2
                                            ? "primary"
                                            : item.rfqstatus === 3 ||
                                              item.rfqstatus === 5
                                            ? "warning"
                                            : "success"
                                        }
                                        className="waves-effect waves-light orderlist_but p-1"
                                      >
                                        <i className="mdi mdi-file-document mr-1"></i>
                                        {item.code}
                                      </Button>
                                    </Link>
                                  </td>
                                  <td>
                                    <Link
                                      to="#"
                                      className="m-0"
                                      onClick={() =>
                                        this.props.rf_model_list_open(item.id)
                                      }
                                    >
                                      {item.items_count} Items
                                    </Link>
                                  </td>

                                  <td>
                                    {moment(item.createdon).format(
                                      "DD-MM-YYYY"
                                    )}
                                  </td>
                                  <td>{item.vendors_count} No</td>

                                  <td>
                                    <Button
                                      outline
                                      size="sm"
                                      type="button"
                                      color="secondary "
                                      className="waves-effect waves-light mr-2"
                                      onClick={() => this.DownloadPDF(item.id)}
                                    >
                                      <i className="mdi mdi-file-pdf"></i>
                                    </Button>
                                    <Button
                                      outline
                                      size="sm"
                                      type="button"
                                      color="danger"
                                      className="waves-effect waves-light"
                                      onClick={() => this.deleteRecord(item.id)}
                                    >
                                      <i className="mdi mdi-delete icon-large "></i>
                                    </Button>
                                  </td>
                                </tr>
                              ))}
                            </>
                          ) : (
                            <tr>
                              <td colspan="7" className="text-center">
                                <span className="font-size-18 text-danger">
                                  Data not available
                                </span>
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </Table>
                    </div>
                  </CardBody>
                )}
                {this.props.layout === "list" && (
                  <>
                    {this.props.RFQRowListCount !== 0 ? (
                      <>
                        {this.props.RFQrowlist?.map((item, key) => (
                          <div className="bg_color p-2 mb-1" key={key}>
                            <Row className="justify-content-center">
                              <Col md={2}>
                                <div className="Material_detiles p-2">
                                  <Link to={`rfq/${item.id}`}>
                                    <Button
                                      type="button"
                                      color={
                                        item.rfqstatus === 1 ||
                                        item.rfqstatus === 2
                                          ? "primary"
                                          : item.rfqstatus === 3 ||
                                            item.rfqstatus === 5
                                          ? "warning"
                                          : "success"
                                      }
                                      className="waves-effect waves-light orderlist_but p-1 mb-2"
                                      href={`rfq/${item.id}`}
                                    >
                                      <i className="mdi mdi-file-document mr-1"></i>
                                      {item.code}
                                    </Button>
                                  </Link>
                                  <p className="items_title m-1">
                                    List Items:{" "}
                                    <span className="item_title_Detiles">
                                      {item.items_count}
                                    </span>
                                  </p>
                                  <Link
                                    to="#"
                                    className="m-0"
                                    onClick={() =>
                                      this.props.rf_model_list_open(item.id)
                                    }
                                  >
                                    <i className="mdi mdi-plus"></i>
                                    More Details
                                  </Link>
                                </div>
                              </Col>
                              <Col md={10}>
                                <div className="Material_body">
                                  <div className="float-right ml-3">
                                    <ButtonGroup>
                                      <Dropdown
                                        isOpen={item.actionMenu}
                                        toggle={() =>
                                          this.props.toggleItemMenu(item.id)
                                        }
                                      >
                                        <DropdownToggle
                                          caret
                                          color="light"
                                          size="sm"
                                        >
                                          <i className="ri-more-line "></i>
                                        </DropdownToggle>
                                        <DropdownMenu right>
                                          <DropdownItem
                                            // disabled={
                                            //   item.pistatus === 1 ||
                                            //   item.pistatus === 2
                                            //     ? false
                                            //     : true
                                            // }
                                            href="#"
                                            onClick={() =>
                                              this.DownloadPDF(item.id)
                                            }
                                          >
                                            Download PDF
                                          </DropdownItem>
                                          <DropdownItem
                                            // disabled={
                                            //   item.pistatus === 1 ||
                                            //   item.pistatus === 2
                                            //     ? false
                                            //     : true
                                            // }
                                            href="#"
                                            onClick={() =>
                                              this.deleteRecord(item.id)
                                            }
                                          >
                                            Delete Request
                                          </DropdownItem>
                                        </DropdownMenu>
                                      </Dropdown>{" "}
                                    </ButtonGroup>
                                  </div>
                                  {/* <p className="mb-1 body_title">{pin.description}</p> */}
                                </div>
                                {/* <hr className="my-0" /> */}
                                <Row className="p-0">
                                  <Col md={8} className="p-0">
                                    <div className="Material-panel-content">
                                      <div className="list-column">
                                        <ul className="list-style-seven p-0">
                                          <li className="clearfix">
                                            <span className="ttl">
                                              SUBMITED:
                                            </span>
                                            <span className="dtl">
                                              {moment(item.createdon).format(
                                                "DD-MM-YYYY"
                                              )}
                                            </span>
                                          </li>
                                          <li className="clearfix">
                                            <span className="ttl">
                                              Vendors :
                                            </span>
                                            <span className="dtl">
                                              {item.vendors_count} No
                                            </span>
                                          </li>
                                          <li className="clearfix">
                                            <span className="ttl">
                                            RFQ Status :
                                            </span>
                                            <span className="dtl">
                                              {item.rfqstatus_name}
                                            </span>
                                          </li>
                                        </ul>
                                      </div>
                                    </div>
                                  </Col>
                                  <Col md={4}>
                                    <div className="float-right">
                                      <ul className="user-column p-0">
                                        <li className="clearfix p-0 m-0">
                                          <span className="img">
                                            <img
                                              className="img-fluid p-0"
                                              src={
                                                item.createdby.image == null
                                                  ? Defaultuser
                                                  : item.createdby?.image
                                              }
                                              alt="user"
                                            />
                                          </span>
                                          <span className="ttl">
                                            {item.createdby.fullname}
                                          </span>
                                        </li>
                                      </ul>
                                    </div>
                                  </Col>
                                </Row>
                              </Col>
                            </Row>
                          </div>
                        ))}
                      </>
                    ) : (
                      <div className="text-center">
                        <span className="font-size-24 text-danger">
                          Data not available{" "}
                        </span>
                      </div>
                    )}
                  </>
                )}
              </CardBody>
            </Card>
          </SimpleBar>
        </div>
      </React.Fragment>
    );
  }
}

const mapStatetoProps = (state) => {
  const {
    RFQrowlist,
    RFQRowListCount,
    params,
    Sortvar,
    RFlistModel,
    layout,
    loading,
  } = state.RequestForQuotation;

  return {
    RFQrowlist,
    RFQRowListCount,
    params,
    Sortvar,
    RFlistModel,
    layout,
    loading,
  };
};

export default withRouter(
  connect(mapStatetoProps, {
    SetParams,
    getRFQRequestList,
    toggleItemMenu,
    rf_model_list_open,
    listlayout,
    generateRFQasPDF,
    rfqPdf,
  })(AllRequestForQuotation)
);
